export const ROW_PER_PAGE_OPTIONS = [10, 25, 50]
